(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["checkout-feedback"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.checkout-feedback').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';

    const form = section.querySelector('.checkout-feedback__form');
    if (!form) return;

    const params = new URLSearchParams(window.location.search);
    const reasonMap = {
      shipping: 'Shipping cost too high',
      price: 'Total price too high',
      time: 'Need more time to decide',
      delivery: 'Delivery option or date issue',
      payment: 'Payment or checkout problem',
      other: 'Other'
    };
    const reason = reasonMap[params.get('reason')];
    const email = params.get('email');
    const checkout = params.get('checkout');
    const otherInput = form.querySelector('[data-feedback-other]');
    const otherField = form.querySelector('[data-feedback-other-field]');
    const otherText = otherField ? otherField.querySelector('input') : null;
    const emailInput = form.querySelector('input[type="email"]');
    const referenceInput = form.querySelector('[data-feedback-reference]');

    if (reason) {
      const selected = Array.from(form.querySelectorAll('input[name="contact[Feedback reason]"]')).find((input) => input.value === reason);
      if (selected) selected.checked = true;
    }
    if (email && emailInput) emailInput.value = email;
    if (checkout && referenceInput) referenceInput.value = checkout;

    const updateOther = () => {
      if (!otherField || !otherInput || !otherText) return;
      const isOther = otherInput.checked;
      otherField.hidden = !isOther;
      otherText.required = isOther;
      if (isOther && document.activeElement === otherInput) otherText.focus();
    };

    form.querySelectorAll('input[name="contact[Feedback reason]"]').forEach((input) => {
      input.addEventListener('change', updateOther);
    });
    updateOther();

    form.addEventListener('submit', () => {
      const submit = form.querySelector('button[type="submit"]');
      if (submit) submit.disabled = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozy-b2b-cart"]) return;
  try {
    
  function initializeOzyTradeCartQuantities(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-ozy-cart-quantity]:not([data-quantity-ready])').forEach((control) => {
      control.dataset.quantityReady = 'true';
      const input = control.querySelector('input[name="updates[]"]');
      const minus = control.querySelector('[data-ozy-cart-quantity-step="-1"]');
      const plus = control.querySelector('[data-ozy-cart-quantity-step="1"]');
      const minimum = Math.max(1, Number(control.dataset.quantityMin) || 1);
      const increment = Math.max(1, Number(control.dataset.quantityIncrement) || 1);
      const maximum = input.max ? Number(input.max) : Infinity;
      const sync = () => {
        const value = Number(input.value) || minimum;
        minus.disabled = value <= minimum;
        plus.disabled = value >= maximum;
      };
      [minus, plus].forEach((button) => {
        button.addEventListener('click', () => {
          const current = Number(input.value) || minimum;
          const direction = Number(button.dataset.ozyCartQuantityStep);
          input.value = String(Math.min(maximum, Math.max(minimum, current + direction * increment)));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeOzyTradeCartQuantities(document));
  } else {
    initializeOzyTradeCartQuantities(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeOzyTradeCartQuantities(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozy-b2b-portal"]) return;
  try {
    
  function initOzyB2BPickupAvailability(root) {
    const scope = root || document;
    const targets = scope.querySelectorAll('[data-ozy-stock-url]:not([data-stock-loaded])');

    targets.forEach(async (target) => {
      target.setAttribute('data-stock-loaded', 'loading');

      try {
        const response = await fetch(target.dataset.ozyStockUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error('Pickup availability request failed');

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        ['brisbane', 'sydney'].forEach((location) => {
          const source = parsed.querySelector('[data-stock-location="' + location + '"]');
          const destination = target.querySelector('[data-stock-location="' + location + '"]');

          if (source && destination) {
            destination.className = source.className;
            destination.textContent = source.textContent.trim();
          } else if (destination) {
            destination.textContent = destination.dataset.fallback;
          }
        });

        target.querySelectorAll('[data-stock-location]').forEach((stock) => {
          stock.dataset.variantStockClass = stock.className;
          stock.dataset.variantStockText = stock.textContent.trim();
        });
        target.dataset.stockRequestState = 'true';
        target.setAttribute('data-stock-loaded', 'true');
        applyOzyB2BWarehouseFilter(scope);
      } catch (error) {
        target.querySelectorAll('[data-stock-location]').forEach((destination) => {
          destination.textContent = destination.dataset.fallback;
        });
        target.dataset.stockRequestState = 'error';
        target.setAttribute('data-stock-loaded', 'error');
        applyOzyB2BWarehouseFilter(scope);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initOzyB2BPickupAvailability(document));
  } else {
    initOzyB2BPickupAvailability(document);
  }

  function getOzyB2BPortal(root) {
    if (root && root.matches && root.matches('[data-ozy-b2b-portal]')) return root;
    return (root || document).querySelector('[data-ozy-b2b-portal]');
  }

  
  function initOzyB2BBulkOrder(root) {
    const scope = getOzyB2BPortal(root);
    if (!scope || scope.dataset.bulkOrderReady) return;

    const filter = scope.querySelector('[data-ozy-b2b-warehouse-filter]');
    const addButton = scope.querySelector('[data-ozy-b2b-add-selected]');
    const selectedCount = scope.querySelector('[data-ozy-b2b-selected-count]');
    const status = scope.querySelector('[data-ozy-b2b-bulk-status]');
    const rows = Array.from(scope.querySelectorAll('[data-ozy-b2b-row]'));

    if (!addButton || !rows.length) return;
    scope.dataset.bulkOrderReady = 'true';

    const syncSelection = () => {
      const selected = rows.filter((row) => row.querySelector('[data-ozy-b2b-select]').checked);
      selectedCount.textContent = selected.length + ' ' + scope.dataset.selectedText;
      addButton.disabled = selected.length === 0;

      rows.forEach((row) => {
        const checkbox = row.querySelector('[data-ozy-b2b-select]');
        const quantity = row.querySelector('[data-ozy-b2b-quantity]');
        quantity.disabled = !checkbox.checked;
        row.classList.toggle('is-selected', checkbox.checked);
      });
    };

    rows.forEach((row) => {
      row.querySelector('[data-ozy-b2b-select]').addEventListener('change', syncSelection);
    });

    if (filter) {
      filter.addEventListener('change', () => applyOzyB2BWarehouseFilter(scope));
    }

    addButton.addEventListener('click', async () => {
      const selectedRows = rows.filter((row) => row.querySelector('[data-ozy-b2b-select]').checked);
      const items = selectedRows.map((row) => {
        const checkbox = row.querySelector('[data-ozy-b2b-select]');
        const quantity = row.querySelector('[data-ozy-b2b-quantity]');
        return {
          id: Number(checkbox.dataset.variantId),
          quantity: Math.max(1, Number(quantity.value) || 1)
        };
      });

      if (!items.length) return;

      addButton.disabled = true;
      addButton.textContent = scope.dataset.addingText;
      status.textContent = '';

      try {
        const addResponse = await fetch(scope.dataset.cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!addResponse.ok) throw new Error('Bulk add failed');

        const cartResponse = await fetch(scope.dataset.cartJsonUrl, {
          headers: { Accept: 'application/json' }
        });
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();

        scope.querySelectorAll('[data-ozy-b2b-cart-count]').forEach((counter) => {
          counter.textContent = cart.item_count;
        });

        document.querySelectorAll('.ozy-b2b-actions a').forEach((link) => {
          if (new URL(link.href).pathname === scope.dataset.cartPageUrl) {
            link.textContent = scope.dataset.cartLabel + ' (' + cart.item_count + ')';
          }
        });

        const totalAdded = items.reduce((total, item) => total + item.quantity, 0);
        status.textContent = totalAdded + ' ' + scope.dataset.itemsAddedText;

        selectedRows.forEach((row) => {
          row.querySelector('[data-ozy-b2b-select]').checked = false;
          row.querySelector('[data-ozy-b2b-quantity]').value = 1;
        });
        syncSelection();
      } catch (error) {
        status.textContent = scope.dataset.errorText;
      } finally {
        addButton.textContent = scope.dataset.addSelectedText;
        syncSelection();
      }
    });

    syncSelection();
    applyOzyB2BWarehouseFilter(scope);
  }

  initOzyB2BBulkOrder(document);
  document.addEventListener('shopify:section:load', (event) => {
    initOzyB2BPickupAvailability(event.target);
    initOzyB2BBulkOrder(event.target);
  });

  function injectOzyB2BMobileStyles() {
    if (document.getElementById('ozy-b2b-mobile-portal-styles')) return;
    const style = document.createElement('style');
    style.id = 'ozy-b2b-mobile-portal-styles';
    style.textContent = [
      '[data-ozy-b2b-portal][data-ozy-b2b-warehouse="sydney"] .ozy-b2b-table th:nth-child(5),',
      '[data-ozy-b2b-portal][data-ozy-b2b-warehouse="sydney"] .ozy-b2b-table td:nth-child(5),',
      '[data-ozy-b2b-portal][data-ozy-b2b-warehouse="sydney"] .ozy-b2b-variant-card > div:has([data-stock-location="brisbane"]) { display: none !important; }',
      '[data-ozy-b2b-portal][data-ozy-b2b-warehouse="brisbane"] .ozy-b2b-table th:nth-child(6),',
      '[data-ozy-b2b-portal][data-ozy-b2b-warehouse="brisbane"] .ozy-b2b-table td:nth-child(6),',
      '[data-ozy-b2b-portal][data-ozy-b2b-warehouse="brisbane"] .ozy-b2b-variant-card > div:has([data-stock-location="sydney"]) { display: none !important; }',
      '.ozy-b2b-view-sizes { display: inline-flex; align-items: center; justify-content: center; min-height: 3.8rem; padding: .8rem 1.1rem; border: 1px solid #17362b; border-radius: .7rem; color: #17362b; font-weight: 700; text-decoration: none; }',
      '[data-ozy-b2b-row][data-ozy-b2b-duplicate="true"] { display: none !important; }',
      'body:has([data-ozy-b2b-portal]) nav { scrollbar-width: none; }',
      'body:has([data-ozy-b2b-portal]) nav::-webkit-scrollbar { display: none; }',
      '@media screen and (max-width: 749px) {',
      '.ozy-b2b-portal { padding: 1.2rem 1.2rem 3rem; }',
      '.ozy-b2b-hero { display: block; margin-bottom: 1.4rem; padding: 1.8rem 1.5rem; border-radius: 1rem; }',
      '.ozy-b2b-title { font-size: 2.9rem; line-height: 1.08; }',
      '.ozy-b2b-intro { margin-top: .7rem; font-size: 1.45rem; line-height: 1.5; }',
      '.ozy-b2b-toolbar, .ozy-b2b-bulk-actions { display: grid; grid-template-columns: 1fr; gap: .9rem; align-items: stretch; }',
      '.ozy-b2b-warehouse-filter, .ozy-b2b-warehouse-filter select, .ozy-b2b-bulk-actions > * { width: 100%; }',
      '.ozy-b2b-table-wrap { overflow: visible; border: 0; background: transparent; }',
      '.ozy-b2b-table, .ozy-b2b-table tbody, .ozy-b2b-table tr, .ozy-b2b-table td { display: block; width: 100%; }',
      '.ozy-b2b-table thead { display: none; }',
      '.ozy-b2b-table tr { margin: 0 0 1rem; padding: 1.25rem; border: 1px solid #d7e0dc; border-radius: 1rem; background: #fff; }',
      '.ozy-b2b-table tr { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 1rem; }',
      '.ozy-b2b-table td { display: block; min-width: 0; }',
      '.ozy-b2b-table td::before { display: block; margin-bottom: .45rem; }',
      '.ozy-b2b-table td:has(.ozy-b2b-product), .ozy-b2b-table td:last-child { grid-column: 1 / -1; }',
      '.ozy-b2b-table td:nth-child(2) { grid-column: 1; grid-row: 2; }',
      '.ozy-b2b-table td:nth-child(3) { grid-column: 1; grid-row: 3; }',
      '.ozy-b2b-table td:nth-child(4) { grid-column: 1; grid-row: 4; }',
      '.ozy-b2b-table td:nth-child(5) { grid-column: 2; grid-row: 3; }',
      '.ozy-b2b-table td:nth-child(6) { grid-column: 2; grid-row: 4; }',
      '.ozy-b2b-table td:last-child { grid-row: 5; }',
      '.ozy-b2b-table td { padding: .55rem 0; border: 0; }',
      '.ozy-b2b-table td::before { content: attr(data-label); color: #61716b; font-size: 1.1rem; font-weight: 700; }',
      '.ozy-b2b-table td:has(.ozy-b2b-product) { padding-top: 0; }',
      '.ozy-b2b-table td:has(.ozy-b2b-product)::before, .ozy-b2b-table td:last-child::before { display: none; }',
      '.ozy-b2b-product { display: grid; grid-template-columns: 6.4rem 1fr; gap: 1rem; align-items: center; }',
      '.ozy-b2b-product img, .ozy-b2b-product__placeholder { width: 6.4rem; height: 6.4rem; border-radius: .7rem; object-fit: cover; }',
      '.ozy-b2b-product a { font-size: 1.55rem; line-height: 1.28; }',
      '.ozy-b2b-table td:last-child { padding-bottom: 0; }',
      '.ozy-b2b-view-sizes { width: 100%; }',
      '.ozy-b2b-product-layout { grid-template-columns: 1fr; gap: 1.4rem; }',
      '.ozy-b2b-product-panel { padding: 1.5rem; }',
      '.ozy-b2b-variant-card { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1rem; padding: 1.2rem; }',
      '.ozy-b2b-variant-card .ozy-b2b-order-form { grid-column: 1 / -1; }',
      '}'
    ].join('');
    document.head.appendChild(style);
    
  }

  function compactOzyB2BCollection(scope) {
    const body = scope.querySelector('.ozy-b2b-table tbody');
    if (!body) return;
    const groups = new Map();
    body.querySelectorAll('[data-ozy-b2b-row]').forEach((row) => {
      const link = row.querySelector('.ozy-b2b-product a');
      if (!link) return;
      const productKey = row.dataset.ozyB2bProduct || link.href;
      if (!groups.has(productKey)) groups.set(productKey, []);
      groups.get(productKey).push(row);
    });
    const lowest = (values) => {
      const prices = values.map((text) => ({ text, number: Number(text.replace(/[^0-9.]/g, '')) })).filter((price) => !Number.isNaN(price.number));
      prices.sort((a, b) => a.number - b.number);
      return prices.length ? prices[0].text : '';
    };
    groups.forEach((group) => {
      const lead = group[0];
      const productUrl = lead.querySelector('.ozy-b2b-product a').href;
      const cells = lead.querySelectorAll('td');
      const allLoaded = group.every((row) => ['true', 'error'].includes(row.dataset.stockRequestState));
      ['brisbane', 'sydney'].forEach((location) => {
        const stocks = group.map((row) => row.querySelector('[data-stock-location="' + location + '"]')).filter(Boolean);
        const availableStock = stocks.find((stock) => (stock.dataset.variantStockClass || '').split(' ').includes('ozy-b2b-stock--available'));
        const available = Boolean(availableStock);
        const destination = lead.querySelector('[data-stock-location="' + location + '"]');
        const source = availableStock || (allLoaded && group.every((row) => row.dataset.stockRequestState === 'true') ? stocks[0] : null);
        if (destination && source) {
          destination.className = source.dataset.variantStockClass;
          destination.textContent = source.dataset.variantStockText;
        } else if (destination) {
          destination.className = 'ozy-b2b-stock ozy-b2b-stock--unknown';
          destination.textContent = allLoaded ? destination.dataset.fallback : scope.dataset.checkingStockText;
        }
        lead.dataset['ozyB2b' + location.charAt(0).toUpperCase() + location.slice(1) + 'Available'] = available ? 'true' : 'false';
      });
      lead.dataset.stockLoaded = allLoaded ? (group.some((row) => row.dataset.stockRequestState === 'error') ? 'error' : 'true') : 'loading';
      group.slice(1).forEach((row) => { row.dataset.ozyB2bDuplicate = 'true'; row.hidden = true; });
      if (lead.dataset.ozyB2bCompacted === 'true') return;
      lead.dataset.ozyB2bCompacted = 'true';
      const retail = lowest(Array.from(group, (row) => { const node = row.querySelector('.ozy-b2b-retail-price'); return node ? node.textContent.trim() : ''; }).filter(Boolean));
      const trade = lowest(Array.from(group, (row) => { const node = row.querySelector('.ozy-b2b-trade-price'); return node ? node.textContent.trim() : ''; }).filter(Boolean));
      if (cells[1]) cells[1].innerHTML = '<a class="ozy-b2b-view-sizes" href="' + productUrl + '">View sizes (' + group.length + ')</a>';
      const retailNode = cells[2] && cells[2].querySelector('.ozy-b2b-retail-price');
      const tradeNode = cells[3] && cells[3].querySelector('.ozy-b2b-trade-price');
      if (retailNode && retail) retailNode.textContent = 'From ' + retail;
      if (tradeNode && trade) tradeNode.textContent = 'From ' + trade;
      if (cells[6]) cells[6].innerHTML = '<a class="ozy-b2b-view-sizes" href="' + productUrl + '">Choose size</a>';
    });
  }

  function applyOzyB2BWarehouseFilter(root) {
    const scope = getOzyB2BPortal(root);
    if (!scope) return;
    const filter = scope.querySelector('[data-ozy-b2b-warehouse-filter]');
    const emptyMessage = scope.querySelector('[data-ozy-b2b-filter-empty]');
    if (!filter) return;
    injectOzyB2BMobileStyles();
    try {
      const remembered = sessionStorage.getItem('ozyB2BWarehouse');
      if (!scope.dataset.warehouseInitialized && ['brisbane', 'sydney'].includes(remembered)) filter.value = remembered;
      scope.dataset.warehouseInitialized = 'true';
      sessionStorage.setItem('ozyB2BWarehouse', filter.value);
    } catch (error) {}
    scope.dataset.ozyB2bWarehouse = filter.value;
    compactOzyB2BCollection(scope);
    let visibleRows = 0;
    let pendingRows = 0;
    scope.querySelectorAll('[data-ozy-b2b-row]').forEach((row) => {
      if (row.dataset.ozyB2bDuplicate === 'true') { row.hidden = true; return; }
      const loaded = row.dataset.stockLoaded === 'true';
      const key = 'ozyB2b' + filter.value.charAt(0).toUpperCase() + filter.value.slice(1) + 'Available';
      const stock = row.querySelector('[data-stock-location="' + filter.value + '"]');
      const available = row.dataset[key] === 'true' || (stock && stock.classList.contains('ozy-b2b-stock--available'));
      const visible = filter.value === 'all' || !loaded || available;
      row.hidden = !visible;
      if (visible) visibleRows += 1;
      if (!loaded) pendingRows += 1;
    });
    if (emptyMessage) emptyMessage.hidden = visibleRows > 0 || pendingRows > 0;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectOzyB2BMobileStyles);
  } else {
    injectOzyB2BMobileStyles();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozy-home-film"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ozy-home-film')){
  customElements.define('ozy-home-film',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.video=this.querySelector('video');this.button=this.querySelector('[data-film-toggle]');
      if(!this.video||!this.button)return;
      this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
      this.userPaused=this.dataset.autoplay!=='true'||this.reduced.matches||Boolean(window.Shopify?.designMode);
      this.video.controls=false;this.video.muted=true;this.button.hidden=false;
      const label=()=>{const text=this.video.paused?'Play video':'Pause video';this.button.textContent=text;this.button.setAttribute('aria-label',text);};
      this.button.addEventListener('click',()=>{
        this.userPaused=!this.video.paused;
        if(this.userPaused)this.video.pause();else this.video.play().catch(label);
      },options);
      this.video.addEventListener('play',label,options);this.video.addEventListener('pause',label,options);
      this.observer=new IntersectionObserver(entries=>{
        this.visible=entries[0].isIntersecting;this.sync();
      },{threshold:.15});this.observer.observe(this);
      document.addEventListener('visibilitychange',()=>this.sync(),options);
      this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.userPaused=true;this.sync();},options);
      label();
    }
    sync(){if(this.visible&&!this.userPaused&&!document.hidden)this.video.play().catch(()=>{});else this.video.pause();}
    disconnectedCallback(){this.observer?.disconnect();this.video?.pause();this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozy-home-promises"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ozy-promise-cards')){
  customElements.define('ozy-promise-cards',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.cards=[...this.querySelectorAll('[data-promise-card]')];
      this.classList.add('is-ready');
      this.cards.forEach(card=>{
        card.querySelector('[data-promise-select]').addEventListener('click',()=>this.select(card),options);
        card.addEventListener('pointerenter',e=>{
          if(e.pointerType!=='mouse'||!matchMedia('(min-width:1100px)').matches)return;
          if(this.contains(document.activeElement)&&!card.contains(document.activeElement))return;
          this.select(card);
        },options);
        card.addEventListener('focusin',()=>this.select(card),options);
      });
      document.addEventListener('shopify:block:select',e=>{
        const card=this.cards.find(card=>card.dataset.blockId===e.detail.blockId);
        if(card)this.select(card);
      },options);
    }
    select(selected){
      this.cards.forEach(card=>{
        const active=card===selected;
        card.classList.toggle('is-selected',active);
        card.querySelector('[data-promise-select]').setAttribute('aria-expanded',String(active));
      });
    }
    disconnectedCallback(){this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozy-home-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ozy-slideshow')) {
  customElements.define('ozy-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-slide-index]')];
      this.pauseButton = this.querySelector('[data-pause]');
      this.index = 0; this.focused = false; this.hovered = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || Boolean(window.Shopify?.designMode);
      if (this.slides.length < 2) return;
      this.querySelector('[data-controls]').hidden = false;
      this.dots.forEach(button => button.addEventListener('click', () => { this.paused = true; this.show(Number(button.dataset.slideIndex), true); }, options));
      this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reduced.addEventListener('change', () => { if(this.reduced.matches) this.paused = true; this.schedule(); }, options);
      this.addEventListener('keydown', e => { if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return; e.preventDefault(); this.paused = true; this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1), true); this.dots[this.index].focus(); }, options);
      this.addEventListener('pointerdown', e => { this.startPoint = {x:e.clientX,y:e.clientY}; }, options);
      this.addEventListener('pointerup', e => { if(!this.startPoint) return; const dx=e.clientX-this.startPoint.x,dy=e.clientY-this.startPoint.y; this.startPoint=null; if(Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)*1.5){this.paused=true;this.show(this.index+(dx<0?1:-1),true);} }, options);
      document.addEventListener('shopify:block:select', e => { const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId); if(i>=0){this.paused=true;this.show(i,false);} }, options);
      this.schedule();
    }
    show(index, announce) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { const active=i===this.index; slide.classList.toggle('is-active',active); slide.inert=!active; slide.setAttribute('aria-hidden',String(!active)); this.dots[i].setAttribute('aria-pressed',String(active)); });
      if(announce) this.querySelector('[data-status]').textContent = 'Slide '+(this.index+1)+' of '+this.slides.length;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if(this.pauseButton){this.pauseButton.textContent=this.paused?'Play':'Pause';this.pauseButton.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');}
      if(this.paused || this.hovered || this.focused || document.hidden || this.reduced.matches || this.slides.length<2) return;
      this.timer=setTimeout(()=>this.show(this.index+1,false),Math.max(5000,Number(this.dataset.interval)||7000));
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
